<svg
  width="61"
  height="61"
  viewBox="0 0 61 61"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M36.5557 45.4609L51.7307 30.2859L36.5557 15.1109M9.23071 30.2859L51.3057 30.2859"
    stroke="#121835"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
  />
</svg>
